import {
  Address,
} from '@bigcommerce/checkout-sdk';

export interface B2BAddress extends Address {
  addressId?: string | number;
}


export const addressFieldOptimize = (address: Partial<B2BAddress>) => {
  if (address?.addressId) delete address.addressId

  return address
}
